/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, {Component, PropTypes} from 'react';
import {FormGroup, Container, Input, Label, Button, Col, Modal, ModalHeader, ModalFooter} from 'src/components/Common/reactstrap/lib';

class ModalAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: props.address || {}
    };
    this.submit = this.submit.bind(this);
  }


  changeInput(value) {
    this.setState({
      address: {
        ...this.state.address,
        ...value }
    });
  }

  submit() {
    const address = this.state.address;

    this.props.addOrUpdateAddresses([address]);
    this.props.close();
    //check
    //const isDataValid = !!address.city && !!address.street && !!address.house && !!address.office;
    // if(isDataValid) {
    //
    // }
    // else {
    //   //alert('Пустые поля не заполнены! ');
    // }
  }

  render() {
    let {address} = this.state;
    if (!address) return (<div></div> );

    return (
      <Modal isOpen={this.props.visible} toggle={this.props.close} className={this.props.className}>
        <ModalHeader toggle={this.props.close}>Адрес доставки</ModalHeader>
        <Container>
          <FormGroup row>
            <Col sm={12}>
              <Input type="text" placeholder="Населенный пункт" value={address.city || ''} onChange={(e) => this.changeInput({city: e.target.value})}/>
              <Input type="text" placeholder="Улица" value={address.street || ''} onChange={(e) => this.changeInput({street: e.target.value})}/>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Col sm={6}>
              <Input type="text" placeholder="Дом" value={address.house || ''} onChange={(e) => this.changeInput({house: e.target.value})}/>
            </Col>
            <Col sm={6}>
              <Input type="text" placeholder="Корпус" value={address.building || ''} onChange={(e) => this.changeInput({building: e.target.value})}/>
            </Col>
            <Col sm={6}>
              <Input type="text" placeholder="Строение" value={address.structure || ''} onChange={(e) => this.changeInput({structure: e.target.value})}/>
            </Col>
            <Col sm={6}>
              <Input type="text" placeholder="Квартира \ офис" value={address.office || ''} onChange={(e) => this.changeInput({office: e.target.value})}/>
            </Col>
          </FormGroup>
        </Container>

        <ModalFooter>
          <Button onClick={this.submit}>Сохранить</Button>
        </ModalFooter>
      </Modal>
    );
  }

}

ModalAddress.propTypes = {
  isOpen: PropTypes.bool,

  toggle: PropTypes.func,

  size: PropTypes.string,

  backdrop: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(['static'])
  ]),
  keyboard: PropTypes.bool,

  zIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default ModalAddress;



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/ModalAddress.jsx
 **/